export function webcamInstance(p) {
  const VIDEO_CONSTRAINS = {
    video: {
      width: 640,
      height: 480,
    },
    audio: false,
  };

  p.setup = function () {
    p.noCanvas();
    p.source = p.createCapture(VIDEO_CONSTRAINS);
    p.source.hide();
  };

  p.draw = function () {};
}
